import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as t } from "../SvgIcon.js";
const p = (r) => /* @__PURE__ */ o(t, { ...r, children: /* @__PURE__ */ o("path", { d: "M8.30471 12.667 4.48362 8.84592 3.32404 10.0165l4.99171 4.9918L16.234 7.0679l-1.1706-1.17062L8.30471 12.667Z" }) });
export {
  p as Done
};
//# sourceMappingURL=Done.js.map
